import {
  footerBaseStyle,
  TFooterTheme,
} from '../../base/customComponents/footer';
import { TStyleConfig } from '../../base/types';

export const Footer: TStyleConfig<TFooterTheme> = {
  baseStyle: {
    ...footerBaseStyle,
    footer: {
      ...footerBaseStyle.footer,
      py: ['0', '6'],
      pt: '6',
      bg: 'transparent',
      color: 'black',
    },
    stackGap: '1',
    footerBar: {
      display: 'flex',
      flexDir: ['column', null, 'row'],
      h: 'auto',
      pr: ['0', null, '3'],
      mb: '8',
      gap: '2',
      borderRadius: 'md',
      alignItems: 'center',
      justifyContent: ['center', null, 'unset'],
      '& > img': {
        maxW: '250px',
        h: '35px',
        ml: '0',
      },
    },
    footerLink: {
      fontWeight: 'bold',
      color: 'alpha.600',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinkTel: {
      fontWeight: 'bold',
      color: 'alpha.600',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    customFooterLink: {
      fontWeight: 'bold',
      color: 'alpha.600',
      textTransform: 'capitalize',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinks: {
      mt: '3',
      ml: ['unset', null, 'auto'],
      pb: ['4', null, '0'],
      alignItems: 'center',
      justifyContent: ['space-around', null, 'unset'],
      color: 'alpha.600',
      fontWeight: 'medium',
      flexDir: ['row', null, 'unset'],
      display: 'inline-flex',
    },
    footerContentContainer: {
      px: ['8', 'unset'],
      ...footerBaseStyle.footerContentContainer,
      justifyContent: 'space-between',
      '&': {
        flexDirection: ['column', null, 'column'],
      },
      textAlign: ['center', 'left'],
    },
    nav: {
      ...footerBaseStyle.nav,
      fontSize: 'sm',
      fontWeight: 'medium',
      minW: [null, null, '370px'],
      mt: ['1', '4', 'unset'],
      display: ['flex', 'grid'],
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: 'auto',
      columnGap: '28',
      rowGap: '1',
      alignItems: ['center', 'end'],
      gridTemplateAreas: `
        ". ."
      `,
      '> a': {
        color: 'inherit',
      },
      color: ['alpha.600', 'inherit'],
    },
    emailUs: {
      ...footerBaseStyle.emailUs,
      fontWeight: ['bold', 'unset'],
      fontSize: ['md', 'unset'],
    },
    blurb: {
      ...footerBaseStyle.blurb,
      flex: 'unset',
      textAlign: 'left',
      color: 'black',
      mb: '2',
      ml: [null, '0'],
      mr: [null, null, '4'],
      width: [null, 'auto', '100%'],
    },
    blurbHeading: {
      ...footerBaseStyle.blurbHeading,
      ml: 0,
    },
    blurbHeadingAge: {
      ...footerBaseStyle.blurbHeadingAge,
      border: '4px',
      mb: '2',
    },
    blurbHeadingThink: {
      fontSize: 'lg',
      fontWeight: 'bold',
      maxW: '410px',
      mb: '4',
    },
    blurbContent: {
      ...footerBaseStyle.blurbContent,
      ml: 'unset',
    },
    copyright: {
      ...footerBaseStyle.copyright,
      textAlign: ['center', 'left'],
      mt: '1',
      px: ['8', 'unset'],
      fontWeight: ['semibold', 'medium'],
    },
    container: {
      pb: ['15vw', '20vw', null, '5vw'],
      '&&': {
        px: ['0', '2'],
      },
    },
  },
  sizes: {},
  variants: {},
};
